
<v-container>
  <v-bottom-navigation fixed class="custom-bottom-nav">
    <v-row justify="space-between" align="center" class="px-2">
      <span class="font-weight-bold text-subtitle-1 text-dark">{{ selectedDocuments.length }} Document(s) selected</span>
      <div class="d-flex">
        <button type="button" class="mr-2 btn btn-sm btn-outline-primary" @click="clearSelection" :disabled="isDownloading">Cancel</button>
        <button type="button" class="mr-2 btn btn-sm btn-primary" @click="downloadSelected" :disabled="isDownloading">
          {{ isDownloading ? 'Downloading...' : `Download (${selectedDocuments.length})` }}
        </button>
      </div>
    </v-row>
  </v-bottom-navigation>
</v-container>
